// lib/measureWebPerf.ts
import { onFCP, onLCP } from 'web-vitals';

type PerfPayload = Record<string, number | string | null | undefined>;

function post(name: string, data: PerfPayload) {
  // ① iOS 네이티브(WKWebView)로도 전달하고 싶을 때
  // try {
  //   // WebViewController에서 "perf" 핸들러를 등록해둔 경우
  //   // configuration.userContentController.add(..., name: "perf")
  //   // 와 호환됩니다.
  //   // @ts-ignore
  //   window.webkit?.messageHandlers?.perf?.postMessage?.({ type: name, data });
  // } catch {}
  // ② 콘솔에도 남김
  // eslint-disable-next-line no-console
  console.log(`[PERF:${name}]`, data);
  // ③ (선택) Firebase Analytics로
  // window.firebase?.logEvent?.(name, data); // 프로젝트 헬퍼에 맞게 바꿔 사용
}

// NavigationTiming 수집 (초기 로드 시점)
export function reportNavigationTimings() {
  const nav = (performance.getEntriesByType('navigation')[0] ||
    null) as PerformanceNavigationTiming | null;

  // legacy fallback

  const payload: PerfPayload = {
    url: location.href,
    ttfb: nav && nav.responseStart - nav.startTime,
    dns: nav && nav.domainLookupEnd - nav.domainLookupStart,
    connect: nav && nav.connectEnd - nav.connectStart,
    request: nav && nav.responseStart - nav.requestStart,
    response: nav && nav.responseEnd - nav.responseStart,
    domContentLoaded: nav && nav?.domContentLoadedEventEnd - nav?.startTime,
    load: nav && nav.loadEventEnd - nav.startTime,
    // 사이즈(지원 안 될 수도 있음)
    transferSize: nav?.transferSize ?? null,
    encodedBodySize: nav?.encodedBodySize ?? null,
    decodedBodySize: nav?.decodedBodySize ?? null,
    redirectCount: nav?.redirectCount ?? null,
  };

  post('navigation', payload);
}

// Web Vitals(FCP/LCP) 수집
export function reportWebVitalsBasics() {
  onFCP((m) => {
    post('fcp', { value: m.value, id: m.id });
  });
  onLCP((m) => {
    // 목표: LCP < 2500 (ms)
    post('lcp', {
      value: m.value,
      id: m.id,
      rating:
        m.value < 2500 ? 'good' : m.value < 4000 ? 'needs-improvement' : 'poor',
    });
  });
}

// 초기 로드에서 한 번만 호출
export function setupPerfReporting() {
  // 네비게이션 타이밍은 'load' 뒤에 더 정확해지므로 load 직후에 한 번
  if (document.readyState === 'complete') {
    // 약간 지연해서 사이즈 필드들 채워지게
    setTimeout(reportNavigationTimings, 0);
  } else {
    window.addEventListener(
      'load',
      () => setTimeout(reportNavigationTimings, 0),
      { once: true }
    );
  }
  // Web Vitals는 즉시 옵저버 등록
  reportWebVitalsBasics();
}
